import { format } from "date-fns";
import { CardType } from "./types";
import { useTodoViewModal } from "./hooks/use-todo-view-modal";
import { useParams } from "react-router-dom";

type CardProps = {
  cardInfo: CardType;
};

export const Card = ({ cardInfo }: CardProps) => {
  const { onOpenChange, setTodo } = useTodoViewModal();
  const { empId } = useParams() as {
    empId: string;
  };

  return (
    <>
      <div
        className="cursor-pointer rounded border bg-card dark:bg-neutral-800 p-3 active:cursor-grabbing shadow-sm"
        onClick={() => {
          onOpenChange(true);
          const refineCard = {
            ...cardInfo,
            tasks: cardInfo?.tasks?.filter((task) => {
              const isCurrentEmp = task?.recipient === empId;

              return isCurrentEmp;
            }),
          };
          setTodo(refineCard);
        }}
      >
        <h3 className="text-base font-medium text-card-foreground">
          {cardInfo?.title}
        </h3>
        <p className="text-xs text-card-foreground truncate">
          {cardInfo?.description}
        </p>

        <p className="text-right text-xs">
          {format(new Date(cardInfo?.createdAt as string), "PPP")}
        </p>
      </div>
    </>
  );
};
